import { useEffect } from 'react';

const useSEO = (title, description, keywords, image, url, favicon) => {
    useEffect(() => {
        const siteUrl = window.location.origin;
        
        let imageUrl = image;
        if (typeof image === 'object' && image !== null && image.src) {
            imageUrl = image.src;
        }

        const fullUrl = url ? (url.startsWith('http') ? url : `${siteUrl}${url}`) : window.location.href;
        const fullImage = imageUrl ? (imageUrl.startsWith('http') ? imageUrl : `${siteUrl}${imageUrl}`) : `${siteUrl}/logo.png`;

        // Helper to set meta tag
        const setMeta = (name, content, isProperty = false) => {
            if (!content) return;
            const attr = isProperty ? 'property' : 'name';
            let element = document.querySelector(`meta[${attr}="${name}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attr, name);
                document.head.appendChild(element);
            }
            element.setAttribute('content', content);
        };

        // Update Title
        let finalTitle = title;
        if (title) {
            const suffix = " - عبدالله العمري";
            if (!title.includes(suffix)) {
                finalTitle = `${title}${suffix}`;
            }
            document.title = finalTitle;
        }

        // Standard Meta
        setMeta('description', description);
        setMeta('keywords', keywords);

        // Open Graph / Facebook
        setMeta('og:type', 'website', true);
        setMeta('og:url', fullUrl, true);
        setMeta('og:title', finalTitle, true);
        setMeta('og:description', description, true);
        setMeta('og:image', fullImage, true);

        // Twitter
        setMeta('twitter:card', 'summary_large_image');
        setMeta('twitter:url', fullUrl);
        setMeta('twitter:title', finalTitle);
        setMeta('twitter:description', description);
        setMeta('twitter:image', fullImage);

        // Update Favicon (Restored)
        if (favicon) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = favicon;
        }

    }, [title, description, keywords, image, url, favicon]);
};

export default useSEO;
